import { render, staticRenderFns } from "./TabsContainerTablist.vue?vue&type=template&id=7a1c71d0&"
import script from "./TabsContainerTablist.vue?vue&type=script&lang=js&"
export * from "./TabsContainerTablist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports